"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.phoneSelector = phoneSelector;
var _formatString = require("../../../../utils/formatString");
function phoneSelector(state) {
  return (0, _formatString.formatPhone)(state.authentication.twoFactor.phoneState.phone);
}